export const sec = 1000
export const min = 60 * sec
export const h = 60 * min
export const d = 24 * h
export const w = 7 * d
